import { useMyProfile } from "../../../common/query/useMyProfile";

/**
 * Safety and privacy are reachable by restricted accounts too. Only an active
 * account sees them inside the app with a way back to Account (which a
 * restricted account can't open).
 */
export function useAccountActive(): boolean {
  // Read what the layout already loaded; never fetch again from here.
  const profile = useMyProfile(false);
  return profile.data?.account_status === "active";
}

export const BACK_TO_ACCOUNT = { to: "/me/account", label: "Account" } as const;
